
import $ from 'jquery';
  $(document).on('click', '.shard__close', function (event) {
    event.preventDefault();
    var $shard = $(event.target).closest('.shard');
    if ($shard.is('paper-toast')) {
      $shard.get(0).toggle();
    } else {
      $shard.one('transitionend', function() {
        $(this).remove();
      }).addClass('shard--closed');
    }
  });
